import React from 'react';
import { ThemeConfig } from '../types';

interface ChatProps {
  theme: ThemeConfig;
}

const Chat: React.FC<ChatProps> = ({ theme }) => {
  return (
    <div>
      <h2 className={`text-2xl font-bold ${theme.text} mb-6`}>
        A Little Chat 💬
      </h2>
      <div className={`max-w-2xl mx-auto ${theme.cardBg} backdrop-blur-sm rounded-2xl p-6 shadow-lg ${theme.shadow} border ${theme.border}`}>
        <div className="space-y-4">
          <div className="flex items-start gap-3">
            <div className={`w-10 h-10 rounded-full ${theme.secondary} flex-shrink-0`}></div>
            <div className={`p-3 rounded-lg rounded-tl-none ${theme.secondary} ${theme.text}`}>
              <p className="font-bold">Me</p>
              <p>Helo! Happy Birthday Yuk!!!. I liked our space together (which you completely made xD) and wanted to bring it back to you so tried to make this ❤️</p>
            </div>
          </div>
          <div className="flex items-start gap-3 justify-end">
            <div className={`p-3 rounded-lg rounded-tr-none ${theme.accent} text-white`}>
              <p className="font-bold">???</p>
              <p>This is not a real chatbot, will have to ask Yuk to implement since she is an expert at making chatbots now :)</p>
            </div>
            <div className={`w-10 h-10 rounded-full ${theme.accent} flex-shrink-0`}></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Chat;